import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import store from "./store/store";
import App from "./App";
import { unregister } from "./registerServiceWorker";
import {
  AuthContext,
  TAuthConfig,
  TRefreshTokenExpiredEvent,
} from "react-oauth2-code-pkce";
import config from "./common/config";
import "./index.scss";
import * as utils from "./common/utils";
import { AuthContextProvider } from "./oidcauthentication/AuthContextProvider";

// const authConfig: TAuthConfig = {
//   clientId: config.CLIENT_ID,
//   authorizationEndpoint: config.SSO_AUTHORITY,
//   tokenEndpoint: config.SSO_TOKENENDPOINT,
//   redirectUri: 'https://nexus.honeywell.com/',
//   scope: 'profile openid email',
//   onRefreshTokenExpire: (event: TRefreshTokenExpiredEvent) => window.confirm('Session expired') && event.login(),
// }

// const devMode = config.DEV_MODENEXUS;
// let isRedirectURISessExist = utils.isRedirectURIExist(window.location.pathname);
// let isUserSessExist = utils.isUserSessExist();
const root = ReactDOM.createRoot(
  document.getElementById("nexus_root") as HTMLElement
);
root.render(
  // <BrowserRouter>
    <AuthContextProvider>
      <Provider store={store}>
        {/* {!devMode ? (
        <AuthProvider authConfig={authConfig}>{<App />}</AuthProvider>
      ) : (
        <App />
      )} */}
        <App />
      </Provider>
    </AuthContextProvider>
  // </BrowserRouter> 
);
unregister();
